// Motion tokens — one vocabulary for every animated surface (nav, cards,
// live numbers). Rules and rationale: DESIGN_SYSTEM.md §Motion.

// Entrances decelerate (fast start, soft landing); exits accelerate away and
// are shorter than entrances, so leaving never feels like waiting.
export const EASE_OUT = [0.22, 1, 0.36, 1]
export const EASE_IN = [0.4, 0, 1, 1]

// Critically damped: settles fast with no overshoot (an overshooting pill,
// drawer or card would briefly detach from its edge).
export const SPRING = { type: 'spring', stiffness: 520, damping: 44, mass: 0.8 }
